// Set to true to enable hardcoded date for testing
const USE_TEST_DATE = true;

// Change this to any date you want to test (e.g., August 5, 2025)

// 1 day before aug 1
// const TEST_DATE = new Date("2025-07-31T04:00:00Z");

// 1 min before aug 1
// const TEST_DATE = new Date("2025-08-01T03:59:00Z");

// 1sec to aug 1 midnight
// const TEST_DATE = new Date("2025-08-01T03:59:59Z");

// aug 1 midnight
// const TEST_DATE = new Date("2025-08-01T04:00:00Z");

const TEST_DATE = new Date("2025-08-30T04:00:01Z");

const START_DATE = new Date("2025-08-01T04:00:00Z");
// This is August 1, 2025, 12:00 AM in New York (EDT, UTC-4)

function getESTDate(date: Date): Date {
  // Convert the given date to EST/EDT (America/New_York)
  const estString = date.toLocaleString("en-US", { timeZone: "America/New_York" });
  return new Date(estString);
}

// Returns the current date (either real or test), always in EST
export function getCurrentDate(): Date {
  const baseDate = USE_TEST_DATE ? TEST_DATE : new Date();
  return getESTDate(baseDate);
}

// Returns the current day in August (1-30), given a start date, always in EST
export function getTodayDay(): number {
  const today = getCurrentDate();
  const start = getESTDate(START_DATE);
  const diff = Math.floor((today.getTime() - start.getTime()) / (1000 * 60 * 60 * 24));
  return diff + 1;
}

// Returns the current month (0-indexed), always in EST
export function getCurrentMonth(): number {
  return getCurrentDate().getMonth();
}

// Returns the current day of the month, always in EST
export function getCurrentDayOfMonth(): number {
  return getCurrentDate().getDate();
}